<template>
  <res-dialog :title="title"
              :showDialog="showDialog"
              :smallTitleIcon="true"
              :cancelButtonOnly="false"
              :iconColor="'white'"
              :iconTitle="iconCode"
              :showTitleIcon="true"
              :titleClass="'resOrange darken-1 white--text'"
              :maxWidth="maxWidth"
              :setWidth="setWidth"
              :titleIconSize="17"
              :saveButtonText="saveButton"
              :saveDisabled="false"
              :cancelButtonText="'CANCEL'"
              :cancelButtonWidth="'80'"
              :defaultButtonAction="confirmAgree"
              @save="confirmAgree"
              @cancel="confirmCancel" >
    <v-card-text>
      <span class="font-weight-500">
         {{message}}
      </span>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  export default {
    components: {
      ResDialog
    },
    props: {
      showDialog: {
        type: Boolean
      },
      maxWidth: {
        type: Number
      },
      setWidth: {
        type: Number
      },
      title: {
        required: true,
        type: String
      },
      message: {
        required: true,
        type: String
      },
      confirmButton: {
        type: String
      }
    },
    methods: {
      confirmCancel() {
        this.$emit('cancelConfirm', true)
      },
      confirmAgree() {
        this.$emit('confirmAgree', true)
      }
    },
    computed: {
      dialogMessage() {
        if (this.message !== undefined && this.message !== null) {
          return this.message
        } else {
          return 'Are you sure you want to take that action?'
        }
      },
      titleMessage() {
        if (this.title !== undefined && this.title !== null) {
          return this.title
        } else {
          return 'Are you sure?'
        }
      },
      iconCode() {
        if (this.iconTitle) {
          return this.iconTitle;
        }
        return 'warning';
      },
      calculateHeight() {
        return "height:" + this.setHeight + "px";
      },
      saveButton() {
        if (this.confirmButton !== undefined && this.confirmButton !== null) {
          return this.confirmButton
        } else {
          return 'CONFIRM'
        }
      }
    }
  }
</script>

